import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Card, Flex, Row, Space, Button } from "antd";

import { CardContainer } from "components/elements";
import BranchList from "components/table/BranchTable";
import { useSelector } from "react-redux";
import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";
import NewAndPolicyFilters from "features/newAndPolicy/components/NewAndPolicyFilter";
import CompanyBranchFilter from "./CompanyBranchFilter";
import { useState } from "react";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as ImportIcon } from "../../../assets/icon/importIcon.svg";

const CompanyBranchMain = ({
  isLoading = false,
  pagination = {},
  branchList = [],
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  onCreate = () => { },
  onView = () => { },
  onEdit = () => { },
  onCancel = () => { },
  onSearch = () => { },
  onStatus = () => { },
  onDelete = () => { },
  onChange = () => { },
}) => {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const [useFilter, setUseFilter] = useState(false);
  return (
    <Space className={styles.container} direction="vertical" size={24}>
      <Row justify="end">
        <Space direction="horizontal" size={12}>
          <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('common.filter')}</span>
            </Flex>
          </Button>
          {/* <Button onClick={() => { }} type="default" style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}>{t("common.download")}</Button>
          <Button type="default" onClick={() => { }} style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8} >
              <ImportIcon />
              <span>{t('common.import')}</span>
            </Flex>
          </Button> */}
          {
            roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|BRANCH") && <Button type="primary" onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                <span>{t('common.create')}</span>
              </Flex>
            </Button>
          }

        </Space>
      </Row>
      {
        useFilter && <Card style={{ border: "solid 1px #EAECF0" }}>
          <CompanyBranchFilter
            isLoading={isLoading}
            pagination={pagination}
            dataSource={branchList}
            provinceOptionsTh={provinceOptionsTh}
            provinceOptionsEn={provinceOptionsEn}
            onEdit={onEdit}
            dataFlag={"branch"}
            onCancel={onCancel}
            onChange={onChange}
            onSubmit={onSearch}
          />
        </Card>
      }

      {/* <CardContainer width="100%" height="fit-content"> */}
      <BranchList
        isLoading={isLoading}
        pagination={pagination}
        dataSource={branchList}
        onView={onView}
        onEdit={onEdit}
        onStatus={onStatus}
        onDelete={onDelete}
        onChange={onChange}
      />
      {/* </CardContainer> */}
    </Space>
  );
};

export default CompanyBranchMain;
